import { render, staticRenderFns } from "./manage-self-assessment.vue?vue&type=template&id=e8fea9be&"
import script from "./manage-self-assessment.vue?vue&type=script&lang=js&"
export * from "./manage-self-assessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports